import React, { type ReactNode } from 'react';

import { type OutsideClickExclusion, useInstantRef, useKeyPress, useOutsideClick } from '@pkg/hooks';
import { noop } from '@pkg/utils';

import { Interior, StyledPopover } from './DepGroupHeader.style';

export interface DepPopoverProps {
    children: ReactNode;
    alignRight?: boolean;
    closeExclusions?: OutsideClickExclusion;
    onClose?(): void;
}

export function DepPopover({ children, alignRight = false, closeExclusions, onClose }: DepPopoverProps) {
    const [popoverElement, popoverRef] = useInstantRef<HTMLDivElement>();

    useKeyPress(['Escape'], onClose ?? noop, {
        disabled: !onClose,
    });

    useOutsideClick(popoverElement, onClose ?? noop, {
        exclude: closeExclusions,
        disabled: !onClose,
    });

    return (
        <StyledPopover ref={popoverRef} $alignRight={alignRight}>
            <Interior>{children}</Interior>
        </StyledPopover>
    );
}
